<template>
  <m-feature-enable-switch feature="helpRequests" />
</template>

<script lang="ts">
import Vue from 'vue';
import MFeatureEnableSwitch from '@/components/Settings/MSettingsFeatures/MFeatureEnableSwitch';

export default Vue.extend({
  name: 'm-settings-features-help-requests',
  components: { MFeatureEnableSwitch },
});
</script>
